/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import cloudLogo from '@/assets/hivemq-enterprise-vert.png'

function PartnerNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node partner-limits">
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Left} />

      <div className="grid grid-cols-1 text-center">
        <div>
          <div>
            <a href={import.meta.env.VITE_CLOUD_CC_ADDRESS} target="_blank">
              <img src={cloudLogo} alt="HiveMQ Partner Logo" className="custom-node-partner-logo" />
            </a>
          </div>
          <div>
            <b>
              External <br /> partners
            </b>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnerNode
